// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sticky[data-v-1dcbd1c6] {\n  position: sticky;\n  top: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
